import { render, staticRenderFns } from "./DialogShop.vue?vue&type=template&id=672ddb80"
import script from "./DialogShop.vue?vue&type=script&lang=js"
export * from "./DialogShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports